/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CSSProperties } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';

const commonTitleStyles: CSSProperties = {
  fontSize: '12px',
  lineHeight: '15px',
  textTransform: 'uppercase',
};

export const useSupportPlansStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  formControl: {
    marginTop: 0,
    marginRight: '15px',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
  title: {
    margin: '0 0 20px 0',
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  supportPlansContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '100%',
    width: '100%',
    marginTop: '10px',
  },
  dynamicAllocation: {
    marginTop: theme.spacing(3),
    gap: theme.spacing(3),
  },
  sliderSection: {
    marginTop: theme.spacing(2),
    gap: theme.spacing(1),
  },
  sliderTitle: {
    ...commonTitleStyles,
  },
}));
